import {UsersService} from "../services/UsersService";
import React from "react";
import Loader from "../components/Loader";
import withRouter from "../components/WithRouter";
import FormGroup from "../components/FormGroup";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import {userService} from "../services/UserService";
import Tablist from "../components/Tablist";
import {Link, Outlet} from "react-router-dom";
import {setTitle, setBreadcrumbs} from "../actions/main";
import {connect} from "react-redux";
import { MultiSelect } from "primereact/multiselect";
// import "primereact/resources/primereact.min.css"
import {Dropdown} from "primereact/dropdown";
import {sendRequest} from "../services/Sender";
import {Formik} from "formik";

class UserEdit extends React.Component {

    constructor(props) {
        super(props);


        this.state = {
            user: null,
            positions: [],
            auths: false,
            tabs: [
                {title: 'Документы', id: 'documents'},
                {title: 'Пароль', id: 'password'},
                {title: 'Финансы', id: 'money'},
                {title: 'Права', id: 'access'},
                {title: 'Обучение', id: 'learning'}
            ],
            formData: {
                departments: [],
                username: '',
                phone: '',
                phone_prefix: '',
                email: ''
            },
            dataSending: false,
            activeTab: props.router.location.pathname.split('/')[3] ? props.router.location.pathname.split('/')[3] : false
        }


        UsersService.GetById(props.router.params.userId).then((response) => {
            this.setState({'user': response, formData: this.initialFormData(response)})
            this.props.setTitle(response.username)
            this.props.setBreadcrumbs([
                {'label': 'Сотрудники', link: 'users'},
                {'label': response.username, link: 'users/' + response.id},
            ])
        })



        console.log(this.props.userData)

        this.handleTabClick = this.handleTabClick.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleUserSave = this.handleUserSave.bind(this)

        this.props.setTitle('Редактировать пользователя')

    }

    initialFormData(user){
        return {
            departments: user.departments.map((d) => {return d.id}),
            email: user.email,
            phone_prefix: user.phone_prefix,
            phone: user.phone,
            username: user.username,
            crm_access: user.crm_access
        }
    }

    componentDidMount() {
        let cleanupFunction = false;
        const fetchData = async () => {
            try {
                UsersService.GetPositions(23).then((response) => {
                    this.setState({positions: response.items})
                })
            } catch (e) {

            }
        }
        fetchData();


        // функция очистки useEffect
        return () => cleanupFunction = true;
    }


    handlePositionSelect() {

    }

    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        switch (name){
            case 'crm_access':
                if(value)
                    value = 1;
                else value = 0;
                break;
        }


        this.setState({
            ...this.state,
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    }

    handleTabClick(tab) {
        console.log(tab)
        this.setState({
            activeTab: tab
        })
        this.props.router.navigate(tab)
    }

    handleUserSave(e){
        e.target.classList.add('disabled')
        this.setState({dataSending: true})
        e.preventDefault()
        sendRequest('users/'+this.state.user.id, 'PUT', this.state.formData, true).then(response => {
            if(response.errors){

            }
            e.target.classList.remove('disabled')
            this.setState({dataSending: false})
        })
    }

    render() {



        if (this.state.user !== null && this.props.userData.auth.userData) {
            return (
                <div className={'edit-profile'}>

                    <div className="row">
                        <div className="col-xl-4">
                            <div className="card">


                                <div className="card-body">

                                    <Formik  onSubmit={(e) => {

                                    }}>


                                        <div className="profile-title">
                                            <div className="media">
                                                <img className="img-70 rounded-circle" alt=""
                                                     src={'http://yii2.easytickets.pro' + this.state.user.avatar}/>
                                                <div className="media-body">
                                                    <h3 className="mb-1 f-20 txt-primary">{this.state.user.username}</h3>
                                                    <p className="f-12">{(this.state.user && this.state.user.position) ? this.state.user.position.name : 'Без должности'}</p>
                                                </div>
                                            </div>
                                        </div>



                                        <FormGroup label={'ФИО'}>
                                            <input type={'text'} className={'form-control'} name={'username'} onChange={this.handleInputChange}
                                                   value={this.state.formData.username}/>
                                        </FormGroup>

                                        <FormGroup label={'Телефон (логин)'}>
                                            <PhoneInput specialLabel={''}
                                                        value={this.state.formData.phone_prefix + this.state.formData.phone} disabled={true}/>
                                        </FormGroup>


                                        <FormGroup label={'Email'}>
                                            <input type={'email'} onChange={this.handleInputChange} name={'email'} className={'form-control'}
                                                   value={this.state.formData.email} />
                                        </FormGroup>

                                        {(this.props.userData && this.props.userData.departments && this.props.userData.departments.length > 0) ?
                                            (<FormGroup label={'Филиал'} style={{display: 'block'}} class={'form-group_block'}>
                                            <MultiSelect display={'chip'}  placeholder={'Выберите филиал'} options={this.props.userData.departments ? this.props.userData.departments.map((el) => {
                                                return {label: el.name, value: el.id}
                                            }) : []} value={this.state.formData.departments} onChange={(e) => this.setState({formData: {...this.state.formData, departments: e.value}})}/>
                                        </FormGroup>)

                                            : <Loader /> }

                                        {/*<small>Указывается общая для всех филиалов.</small>*/}



                                        <div className="form-check checkbox m-b-30">
                                            <input type="checkbox" name={'crm_access'} id={'main-auth'} onChange={this.handleInputChange} checked={this.state.formData.crm_access} className="form-check-input" disabled={this.state.user.id === this.props.userData.auth.userData.id}/>
                                            <label htmlFor={'main-auth'} className="form-check-label">Доступ к системе</label>
                                            {this.state.dataSending && <Loader/>}
                                        </div>



                                        <button type={'submit'} onClick={this.handleUserSave} className={'btn btn-primary'}>Сохранить</button>


                                    </Formik>
                                </div>


                            </div>
                        </div>
                        <div className="col-xl-8">
                            <div className="card project-list">


                                <div className="row">

                                    <div className="col-md-6 p-0">

                                        <ul className="nav nav-tabs border-tab">
                                            {this.state.tabs.map((tab, k) => {
                                                return (
                                                    <li className={'nav-item'} key={'tab-' + k}>
                                                        <a href='#' onClick={() => this.handleTabClick(tab.id)}
                                                           className={'nav-link ' + (this.state.activeTab === tab.id ? 'active' : '')}>{tab.title}</a>
                                                    </li>
                                                )
                                            })}
                                        </ul>

                                    </div>

                                </div>

                            </div>

                            <div className="card">

                                <div className="card-body">
                                    {<Outlet/>}
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            )
        } else {
            return (
                <Loader/>
            )
        }
    }
}

const mapStateToProps = (state) => ({
  userData: state
})

export default connect(
    mapStateToProps,
    {setTitle, setBreadcrumbs}
)(withRouter(UserEdit))

